import React from "react";
import { SourcesAdditonalAllocationRulesContainer } from "../../../containers";

const SourcesAdditonalAllocationRules = (props) => {
  return <SourcesAdditonalAllocationRulesContainer {...props} />;
};

export default SourcesAdditonalAllocationRules;
